import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export type PillStripItem = {
  label: string;
  subLabel?: string;
  note?: string;
  dotClass?: string;
  dotColor?: string;
  dead?: boolean;
  disabled?: boolean;
  value?: any;
  [key: string]: any;
};

@Component({
  selector: 'hospitality-bot-pill-strip',
  templateUrl: './pill-strip.component.html',
  styleUrls: ['./pill-strip.component.scss'],
})
export class PillStripComponent implements OnInit {
  @Input() label: string = '';
  @Input() items: PillStripItem[] = [];
  @Input() selectedIndex: number = 0;
  @Input() selectedValue: any;
  @Input() customWrapperClass: string = '';

  @Output() onSelect = new EventEmitter<{ item: PillStripItem; index: number }>();
  @Output() selectedIndexChange = new EventEmitter<number>();
  @Output() selectedValueChange = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  isSelected(item: PillStripItem, idx: number): boolean {
    if (this.selectedValue !== undefined && item.value !== undefined) {
      return item.value === this.selectedValue;
    }
    return idx === this.selectedIndex;
  }

  selectItem(item: PillStripItem, idx: number): void {
    if (item.disabled) return;
    this.selectedIndex = idx;
    this.selectedValue = item.value !== undefined ? item.value : idx;
    this.selectedIndexChange.emit(idx);
    this.selectedValueChange.emit(this.selectedValue);
    this.onSelect.emit({ item, index: idx });
  }

  getDotClass(item: PillStripItem): string {
    return item.dotClass || '';
  }
}
